var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"},{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],style:({
      bottom: _vm.fab ? '100px' : ''
    }),attrs:{"aria-label":"Scroll to top","bottom":"","small":"","color":"red","dark":"","fab":"","fixed":"","right":"","title":"Scroll to top"},on:{"click":_vm.toTop}},[_c('v-icon',[_vm._v("mdi-rocket")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }